<template>
  <v-card flat tile class="d-flex flex-column" ma-1>
    <v-card-title class="fileListTitle">File List</v-card-title>
    <v-divider color="black"></v-divider>

    <v-container v-if="Object.keys(getActiveFolder).length===0">
      <v-layout>
        <v-flex text-center>
          <p
            class="font-weight-thin"
          >Please select any folder from the "Folder Level" to view its file contents.</p>
        </v-flex>
      </v-layout>
    </v-container>

    <div v-else-if="filesAvailable">
      <v-simple-table fixed-header>
        <template #default>
          <thead>
            <tr>
              <th class="text-left">Display name</th>
              <th class="text-left">File name</th>
              <th class="text-left">Last modified</th>
              <th class="text-left">Modified by</th>
              <th class="text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(file, index) in getActiveFolder.files" :key="file.id">
              <td>{{ file.displayName }}</td>
              <td>
                <v-icon left>{{fileIcons[file.ext]}}</v-icon>
                {{ file.name }}.{{file.ext}}
              </td>
              <td>{{ file.modifiedDate | dateFilter }}</td>
              <td>{{ userFilter(file.modifiedBy) }}</td>
              <td>
                <v-tooltip bottom>
                  <template #activator="{on}">
                    <v-btn text @click="downloadFile(file)" v-on="on">
                      <v-icon>mdi-file-download</v-icon>
                    </v-btn>
                  </template>
                  <span>Download file</span>
                </v-tooltip>

                <v-dialog v-model="editFileDialog[index]" max-width="500">
                  <template #activator="{on: dialog}">
                    <v-tooltip bottom>
                      <template #activator="{on: tooltip}">
                        <v-btn
                          v-on="{...dialog, ...tooltip}"
                          text
                          disabled
                          @click="editClicked(file)"
                        >
                        <!-- <v-btn
                          v-on="{...dialog, ...tooltip}"
                          text
                          :disabled="getActiveFolder.id===''"
                          @click="editClicked(file)"
                        > -->
                          <v-icon>mdi-file-cog</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit file (coming soon)</span>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-card-title class="color5 background--text">Edit file</v-card-title>
                    <form @submit.prevent="onEditFile(file)">
                      <v-container>
                        <v-layout row justify-center align-center>
                          <v-flex xs10>
                            <v-file-input
                              label="Choose file to replace the current file with"
                              max-width="500"
                              show-size
                              prepend-icon="mdi-file"
                              counter
                              accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt"
                              :rules="[fileRules]"
                              @change="onFileSelect"
                              ref="fileToUpload"
                              @click:clear="fileClear"
                            ></v-file-input>
                          </v-flex>
                          <v-flex xs10>
                            <v-text-field label="Display name" :value="file.displayName" disabled></v-text-field>
                          </v-flex>
                          <v-flex xs10>
                            <v-textarea
                              outlined
                              label="Description about the file"
                              v-model="updatedFileDescription"
                              :rules="[fileDescriptionRules]"
                              counter="250"
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-container>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="color3 background--text"
                          :disabled="!editFileFormValid"
                          type="submit"
                        >Update</v-btn>
                      </v-card-actions>
                    </form>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="deleteFileDialog[index]" max-width="500">
                  <template v-slot:activator="{on: dialog}">
                    <v-tooltip bottom>
                      <template #activator="{on: tooltip}">
                        <v-btn v-on="{...dialog, ...tooltip}" text>
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete file</span>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-card-title class="color5 background--text">Delete file ?</v-card-title>
                    <form @submit.prevent="onDeleteFile(file)">
                      <v-container>
                        <v-layout row justify-center align-center>
                          <v-flex xs10>
                            <v-card-text>Are you sure you want to delete the file? This cannot be undone.</v-card-text>
                          </v-flex>
                        </v-layout>
                      </v-container>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="color5 background--text" type="submit">Delete</v-btn>
                      </v-card-actions>
                    </form>
                  </v-card>
                </v-dialog>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <v-container v-else>
      <v-layout>
        <v-flex text-center>
          <p class="font-weight-thin">The selected folder does not contain any files.</p>
        </v-flex>
      </v-layout>
    </v-container>

  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  name: "ExplorerFileList",
  data() {
    return {
      deleteFileDialog: [],
      editFileDialog: [],
      updatedFile: null,
      fileDataUrl: "",
      updatedFileDescription: "",
      fileRules: value =>
        (!!value && value.size < 10000000) ||
        "File size should be less than 10MB",
      fileDescriptionRules: value =>
        (!!value && value.length <= 250) || "Please enter a valid description.",
      displayName: "",
      displayNameRules: value =>
        (!!value && value.length <= 150) || "Please enter a valid description.",
      fileIcons: {
        pdf: "mdi-file-pdf",
        doc: "mdi-file-word",
        docx: "mdi-file-word",
        xls: "mdi-file-excel",
        xlsx: "mdi-file-excel",
        xlsm: "mdi-file-excel",
        ppt: "mdi-presentation",
        zip: "mdi-folder-zip",
        rar: "mdi-folder-zip"
      }
    };
  },
  computed: {
    ...mapGetters(["getActiveFolder", "getAllUsers"]),
    editFileFormValid() {
      return (
        this.updatedFile !== null ||
        (this.updatedFileDescription.length <= 250 &&
          this.updatedFileDescription !== "")
      );
    },
    filesAvailable() {
      if (this.getActiveFolder.files) {
        return (
          this.getActiveFolder.files.length > 0 &&
          this.getActiveFolder.id !== ""
        );
      }
      return false;
    }
  },
  methods: {
    ...mapActions(["downloadFile", "deleteFile", "editFile", "refreshFilemanager"]),
    onDeleteFile(file) {
      this.deleteFile(file);
      this.deleteFileDialog = [];
    },
    onFileSelect(file) {
      this.loading = true;
      if (file) {
        let filename = file.name;
        if (
          !(
            filename.endsWith(".pdf") ||
            filename.endsWith(".doc") ||
            filename.endsWith(".docx") ||
            filename.endsWith(".xlsx") ||
            filename.endsWith(".xls") ||
            filename.endsWith(".ppt")
          )
        ) {
          this.setSuccessMessage(
            "Please select a valid file (.doc, .docx, .pdf, .ppt, .xls, .xlsx)"
          );
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.fileDataUrl = fileReader.result;
        });
        fileReader.readAsDataURL(file);
        this.updatedFile = file;
      }
      this.loading = false;
    },
    onEditFile(file) {
      this.editFile({
        props: file,
        file: this.updatedFile,
        description: this.updatedFileDescription,
        userId: this.user.id
      });
    },
    editClicked(file) {
      this.updatedFileDescription = file.description;
    },
    fileClear() {
      this.updatedFile = null;
      this.fileDataUrl = "";
    },
    userFilter(userId) {
      if (userId in this.getAllUsers) {
        return (
          this.getAllUsers[userId].firstName +
          " " +
          this.getAllUsers[userId].lastName
        );
      } else {
        return "Undefined";
      }
    }
  }
};
</script>

<style scoped>
.file {
  margin: 5px !important;
}
.fileListTitle {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>